module.exports = __webpack_public_path__ + "img/frio-logo-dark.be83a741.png";